// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.permission-tabs-container {
    width: 100%;
}

.permission-tabs_tabs {
    cursor: pointer;
    float: left;
    margin-left: 5rem;
    text-align: left;
}

.permission-tabs_tabs span{
    margin-left: .5rem;
    margin-right: .5rem;
    font-family: Arial, Helvetica, sans-serif;
    font-size: medium;
    cursor: pointer;
    margin-bottom: -2px;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    white-space: nowrap;
}

.permission-tabs_tabs span.active{
    font-weight: bold;
    border-bottom: 2px solid #26a69a;
}`, "",{"version":3,"sources":["webpack://./src/app/permission/permission-main/permission-tabs/PermissionTabs.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;AACpC","sourcesContent":[".permission-tabs-container {\r\n    width: 100%;\r\n}\r\n\r\n.permission-tabs_tabs {\r\n    cursor: pointer;\r\n    float: left;\r\n    margin-left: 5rem;\r\n    text-align: left;\r\n}\r\n\r\n.permission-tabs_tabs span{\r\n    margin-left: .5rem;\r\n    margin-right: .5rem;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    font-size: medium;\r\n    cursor: pointer;\r\n    margin-bottom: -2px;\r\n    -moz-user-select: none;\r\n    -khtml-user-select: none;\r\n    user-select: none;\r\n    white-space: nowrap;\r\n}\r\n\r\n.permission-tabs_tabs span.active{\r\n    font-weight: bold;\r\n    border-bottom: 2px solid #26a69a;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
